import * as _ from "lodash";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class SpinnerService {
    private selector: string = "app-spinner";
    private element: HTMLElement;

    constructor() {
        this.initElement();
    }

    public show() {
        if (_.isNil(this.element)) {
            this.initElement();
        }
        this.element.className = "show";
    }

    public hide() { 
        if (_.isNil(this.element)) {
            this.initElement();
        }
        this.element.className = "spinnerHide";
    }

    private initElement() {
        this.element = document.getElementById(this.selector);
        // console.log(" this.element.className initElement" , this.element)
    }
}
